var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitfront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -90,
    x2: 90,
    y1: 90,
    y2: 270,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03303d",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15c1ff",
    offset: 1
  })))), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45)",
    d: "m-79.197 85.838h158.39c8.8555 0 15.985 7.1291 15.985 15.985v158.39c0 8.8554-7.1291 15.985-15.985 15.985h-158.39c-8.8555 0-15.985-7.1291-15.985-15.985v-158.39c0-8.8555 7.1291-15.985 15.985-15.985z",
    fill: "url(#a)",
    strokeWidth: 0.70268,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 0c-4.086-2.6517e-7 -8.1719 1.5664-11.303 4.6973l-112 112c-6.2618 6.2618-6.2618 16.344 0 22.605l112 112c3.1309 3.1309 7.2168 4.6973 11.303 4.6973z",
    fill: "#004760",
    strokeWidth: 0.70268,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 54a20 20 0 0 0-20 20 20 20 0 0 0 13 18.734v70.531a20 20 0 0 0-13 18.734 20 20 0 0 0 20 20 20 20 0 0 0 20-20 20 20 0 0 0-1.8984-8.5039l27.395-27.395a20 20 0 0 0 8.5039 1.8984 20 20 0 0 0 20-20 20 20 0 0 0-20-20 20 20 0 0 0-20 20 20 20 0 0 0 1.709 8.0879l-27.621 27.621a20 20 0 0 0-1.0879-0.44336v-70.531a20 20 0 0 0 13-18.734 20 20 0 0 0-20-20z",
    fill: "#fff",
    strokeWidth: 0.9421,
    style: {
      paintOrder: "fill markers stroke"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitfront);
export default __webpack_public_path__ + "static/media/gitfront.f8707626104878387266e9a689b01dcb.svg";
export { ForwardRef as ReactComponent };